(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/shared-components/iam-iframe-message-handler.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/shared-components/iam-iframe-message-handler.js');

'use strict';

if (svs.accountservices.check_iam.isIamIFrameEnabled) {
  var _svs;
  const setupParentCommunication = svs.accountservices.iamPostMessage.setupParentCommunication;
  const getReturnUrlForEidApp = svs.playerLoginReact.sharedComponents.iamIframeEidAppHandler.getReturnUrlForEidApp;
  const _svs$playerLoginReact = svs.playerLoginReact.sharedComponents.Dialogs,
    showDialog = _svs$playerLoginReact.showDialog,
    showDialogExtended = _svs$playerLoginReact.showDialogExtended;
  const TRUSTED_REDIRECT_URLS = ((_svs = svs) === null || _svs === void 0 || (_svs = _svs.playerLoginReact) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 ? void 0 : _svs.trustedRedirectUrls) || [];

  const _setupParentCommunica = setupParentCommunication({
      iframeId: 'iamlogin-iframe',
      trustedRedirectUrls: TRUSTED_REDIRECT_URLS,
      handlers: {
        getState: () => {
          const state = svs.playerLoginReact.storeRef.getState();
          return {
            cancelUrl: state.playerloginreact.cancelUrl,
            returnUrl: state.playerloginreact.returnUrl,
            isReturnNewCustomer: state.playerloginreact.isReturnNewCustomer
          };
        },
        showDialog: async (title, errorMessage) => {
          await showDialog(title, errorMessage);
        },
        showDialogExtended: async (title, message, icon, type, actions) => await showDialogExtended(title, message, icon, type, actions),
        getReturnUrlForEidApp: (serializedLoginObject, isBankId) => getReturnUrlForEidApp(serializedLoginObject, isBankId),
        getOnboardingData: async () => {
          var _svs2;
          return await ((_svs2 = svs) === null || _svs2 === void 0 || (_svs2 = _svs2.accountservices) === null || _svs2 === void 0 || (_svs2 = _svs2.onboardingHandler) === null || _svs2 === void 0 ? void 0 : _svs2.getExtraData());
        },
        getTheme: branding => {
          var _branding$toLowerCase;
          return svs.accountservices.onboardingHandler.getTheme((branding === null || branding === void 0 || (_branding$toLowerCase = branding.toLowerCase) === null || _branding$toLowerCase === void 0 ? void 0 : _branding$toLowerCase.call(branding)) || '');
        },
        updateOnboardingData: async onboardingData => await svs.accountservices.onboardingHandler.updateExtraData({
          newExtraData: onboardingData || {}
        }),
        updateOnboardingUrls: async onboardingUrls => new Promise(resolve => {
          svs.core.deviceSession.set('onboardingUrls', 'customer_login', onboardingUrls, () => {
            resolve();
          });
        }),
        setLoginType: async loginType => new Promise(resolve => {
          svs.core.deviceSession.set('loginType', 'iam', loginType, () => {
            resolve();
          });
        }),
        getParentSlo: () => {
          var _svs3;
          return (_svs3 = svs) === null || _svs3 === void 0 || (_svs3 = _svs3.playerLoginReact) === null || _svs3 === void 0 || (_svs3 = _svs3.data) === null || _svs3 === void 0 ? void 0 : _svs3.parentSlo;
        },
        deleteParentSlo: () => {
          var _svs4, _svs5;
          const deletedParentSlo = (_svs4 = svs) === null || _svs4 === void 0 || (_svs4 = _svs4.playerLoginReact) === null || _svs4 === void 0 || (_svs4 = _svs4.data) === null || _svs4 === void 0 ? void 0 : _svs4.parentSlo;
          if ((_svs5 = svs) !== null && _svs5 !== void 0 && (_svs5 = _svs5.playerLoginReact) !== null && _svs5 !== void 0 && (_svs5 = _svs5.data) !== null && _svs5 !== void 0 && _svs5.parentSlo) {
            delete svs.playerLoginReact.data.parentSlo;
            svs.playerLoginReact.data.parentSlo = undefined;
          }
          return deletedParentSlo;
        },
        trackEvent: async trackingObject => new Promise(resolve => {
          svs.components.analytics.trackEvent(trackingObject, () => {
            resolve();
          });
        })
      }
    }),
    stopListening = _setupParentCommunica.stopListening;

  svs.playerLoginReact.stopIamListening = stopListening;
}

 })(window);